import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { adaptedDataHelper } from 'store/schedule/schedulePageOperation';
import Fuse from 'fuse.js';
import { getEventSheetsFuse } from 'pages/ScheduleV6/utils';

const useV6WeekEvents = () => {
  const { weekSheets, searchValue, showAllLocations } = useSelector((state) => state.schedule);
  const locations = useSelector((state) => state.personalProfile.activeLocations);
  const timeFormat = useSelector((store) => store.personalProfile.organization?.settings?.timeFormat);

  const events = useMemo(() => {
    const sortedWeekSheets = Object.entries(weekSheets)
      .map(([key, sheets]) => ({
        key,
        sheets: adaptedDataHelper(sheets, timeFormat)
          .map(sheet => ({
            ...sheet,
            locationColor: showAllLocations
              ? locations.find(({ _id }) => sheet?.sheet?.tenantLocationId === _id)?.color
              : null,
          }))
          .sort((a, b) => new Date(a.start).getTime() - new Date(b.start).getTime())
      }));

    if (!searchValue) {
      return sortedWeekSheets
        .reduce((weekMap, { key, sheets }) => ({ ...weekMap, [key]: sheets }), {});
    }
    const allWeekSheets = sortedWeekSheets.map(({ sheets }) => sheets).flat();
    const fuse = getEventSheetsFuse(allWeekSheets);
    const allFilteredSheets = fuse.search(searchValue);

    const filteredResult = sortedWeekSheets.map(
      ({ key, sheets }) => ({
        key,
        sheets: sheets.filter(sheet => allFilteredSheets.some(s => s._id === sheet._id))
      })
    ).filter(({ sheets }) => sheets.length > 0);
    
    return filteredResult
      .reduce((weekMap, { key, sheets }) => ({ ...weekMap, [key]: sheets }), {});;
  }, [weekSheets, searchValue, timeFormat, showAllLocations, locations])

  return { events }
};

export default useV6WeekEvents;